import { useState } from 'react';
import type { AuditEventDto, PagedResult } from '@shared/types';
import { localDateTime } from '@shared/format';
import { useApp, useLoad } from '../context';
import { query, useRoute } from '../router';
import { Card, Empty, ErrorBox, Loading, TopBar } from '../components/ui';

export function Audit() {
  const { api } = useApp();
  const route = useRoute();
  const drawingId = query(route).get('drawingId') ?? '';
  const [eventType, setEventType] = useState('');
  const [skip, setSkip] = useState(0);
  const [open, setOpen] = useState<number | null>(null);
  const take = 50;
  const q = new URLSearchParams({ skip: String(skip), take: String(take) });
  if (drawingId) q.set('drawingId', drawingId);
  if (eventType) q.set('eventType', eventType);
  const { data, error, loading, reload } = useLoad(() => api.get<PagedResult<AuditEventDto>>(`/api/audit?${q}`), [api, drawingId, eventType, skip]);

  return (
    <div className="page">
      <TopBar title="Audit Log" back="/more" />
      <div className="search-wrap">
        <input className="input" placeholder="Filter by event type, e.g. drawing.winner_selected" value={eventType} onChange={(e) => { setSkip(0); setEventType(e.target.value.trim()); }} />
      </div>
      {drawingId && <p className="muted small pad">Showing events for one drawing. <a href="#/audit">Show all</a></p>}
      {loading && !data && <Loading />}
      {error && <ErrorBox message={error} onRetry={reload} />}
      {data && (
        <Card>
          {data.items.length === 0 ? <Empty>No audit events.</Empty> : data.items.map((a) => (
            <div key={a.auditEventId} className="audit-row">
              <button className="list-row" onClick={() => setOpen(open === a.auditEventId ? null : a.auditEventId)}>
                <div><code>{a.eventType}</code><div className="muted small">{localDateTime(a.createdAtUtc)} • {a.actorId}</div></div>
                <span className="chev">{open === a.auditEventId ? '▾' : '›'}</span>
              </button>
              {open === a.auditEventId && <pre className="payload">{(() => { try { return JSON.stringify(JSON.parse(a.payloadJson), null, 2); } catch { return a.payloadJson; } })()}</pre>}
            </div>
          ))}
          <div className="row-between mt">
            <button className="btn btn-secondary btn-sm" disabled={skip === 0} onClick={() => setSkip(Math.max(0, skip - take))}>Newer</button>
            <span className="muted small">{data.total === 0 ? 0 : skip + 1}–{Math.min(skip + take, data.total)} of {data.total}</span>
            <button className="btn btn-secondary btn-sm" disabled={skip + take >= data.total} onClick={() => setSkip(skip + take)}>Older</button>
          </div>
        </Card>
      )}
    </div>
  );
}
